import script from "./StageThree.vue?vue&type=script&setup=true&lang=js"
export * from "./StageThree.vue?vue&type=script&setup=true&lang=js"

import "./StageThree.vue?vue&type=style&index=0&id=6e035146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e035146"]])

export default __exports__